module.exports = __webpack_public_path__ + "img/RouletteRectangle2.30c90523.png";